import SampleMasterScreen from "components/modules/sample-module/masters/SampleMasterScreen";
import ConfigSettingsScreen from "components/modules/config-module/ConfigSettingsScreen";
import RoleMasterScreen from "components/modules/iam-module/RoleMasterScreen";
import PermissionAssignmentScreen from "components/modules/iam-module/PermissionAssignmentScreen";
import ModuleMasterScreen from "components/modules/iam-module/ModuleMasterScreen";
import ScreenMasterScreen from "components/modules/iam-module/ScreenMasterScreen";
import MenuMasterScreen from "components/modules/iam-module/MenuMasterScreen";
import UserMasterScreen from "components/modules/iam-module/UserMasterScreen";

// Time Tracker module
// TaskDetailScreen is intentionally NOT registered as a module — it renders inline
// from inside TaskListScreen when a row is clicked.
import TtClientMasterScreen from "components/modules/time-tracker/masters/ClientMasterScreen";
import TtProjectMasterScreen from "components/modules/time-tracker/masters/ProjectMasterScreen";
import TtTaskTypeMasterScreen from "components/modules/time-tracker/masters/TaskTypeMasterScreen";
import TtUserMasterScreen from "components/modules/time-tracker/masters/UserMasterScreen";
import TtTaskListScreen from "components/modules/time-tracker/tasks/TaskListScreen";
import TtMyTimesheetScreen from "components/modules/time-tracker/tasks/MyTimesheetScreen";
import TtReportsScreen from "components/modules/time-tracker/reports/ReportsScreen";

export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  SampleMasterScreen: SampleMasterScreen,
  ConfigSettingsScreen: ConfigSettingsScreen,
  RoleMasterScreen: RoleMasterScreen,
  PermissionAssignmentScreen: PermissionAssignmentScreen,
  ModuleMasterScreen: ModuleMasterScreen,
  ScreenMasterScreen: ScreenMasterScreen,
  MenuMasterScreen: MenuMasterScreen,
  UserMasterScreen: UserMasterScreen,

  // Time Tracker
  TtClientMasterScreen,
  TtProjectMasterScreen,
  TtTaskTypeMasterScreen,
  TtUserMasterScreen,
  TtTaskListScreen,
  TtMyTimesheetScreen,
  TtReportsScreen,
};
